import { createRoot } from 'react-dom/client';
import { styled } from 'styled-components';
import { observer } from 'mobx-react-lite';
import { getUserChosenDirectoryHandle } from '../State/FileSystem';
import { AppWindow } from '../components/ExtensionWindow/AppWindow';
import { ProcessInfo } from '../State/ProcessInfo';
import { WindowRoutingState } from '../components/ExtensionWindow/WindowRoutingState';
import searchWorkerUrl from '../ServiceWorker/NetworkEventDbSearchWebWorker?worker&url'
import { DbRecordingsTableWriter } from '../State/EvidenceDB/DbRecordingsTableWriter';

ProcessInfo.setProcess({processType: "Extension UI"});

export const AppContainerElement = styled.div`
	min-height: 100vh;
	width: 100%;
	padding: 1rem;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: start;
	align-items: stretch;
	background-color: rgba(248, 248, 248, 1);
`;


window.history.replaceState(undefined, "", '/');
const domNode = document.getElementById('root')!;
const root = createRoot(domNode);;
(async () => {
	const recordingsTableWriter = await DbRecordingsTableWriter.instancePromise;
	const windowRoutingState = new WindowRoutingState({
		searchWorkerUrl
	}, recordingsTableWriter);
root.render(<AppWindow {...{windowRoutingState}} />);
})();

